module.exports = __webpack_public_path__ + "static/media/peridotdp.bed01813.jpg";